import { SimpleModal } from '@sequencehq/core-components'
import { FC } from 'react'

// Removal is staged into the Cube domain and applied when the schedule is
// saved (the grant is omitted from the save, which removes it server-side).
export const DeleteCreditGrantModal: FC<{
  creditGrantName: string
  onConfirm: () => void
  onClose: () => void
}> = ({ creditGrantName, onConfirm, onClose }) => (
  <SimpleModal
    isOpen
    onClose={onClose}
    variant="dialog"
    title="Delete credit grant"
    submitButtonText="Delete"
    isDestructive
    data-testid="deleteCreditGrant.modal"
    onSubmit={() => {
      onConfirm()
      return true
    }}
  >
    {`This removes "${creditGrantName}" and any remaining balance from the customer's account when you save the schedule. This action cannot be undone.`}
  </SimpleModal>
)
